export const MasterCapabilitiesList = [
    //essential 5 for vtc
    {key:"BallSpeedMph",            display:"Ball Spd",             unit:"Mph"      ,category:"Ball"},
    {key:"BallLaunchAngleDeg",      display:"Launch",               unit:"deg"      ,category:"Ball"},
    {key:"BallSideAngleDeg",        display:"Side Angle",           unit:"deg"      ,category:"Ball"},
    {key:"BallPathAngleDeg",        display:"Path Angle",           unit:"deg"      ,category:"Ball"},
    {key:"BallBackSpinRpm",         display:"Backspin",             unit:"RPM"      ,category:"Ball"},
    {key:"BallSideSpinRpm",         display:"Sidespin",             unit:"RPM"      ,category:"Ball"},
    {key:"Ground",                  display:"Ground",               unit:""         ,category:"Clubhead"},
    {key:"HeadingAtAddress",        display:"Aim",                  unit:"deg"      ,category:"Clubhead"},
    {key:"ImpactHorizLocInch",      display:"Impact X",             unit:"mm"       ,category:"Clubhead"},
    {key:"ImpactVertLocInch",       display:"Impact Y",             unit:"mm"       ,category:"Clubhead"},
    {key:"AdjImpHorizLocInch",      display:"Adj-Impact X",         unit:"mm"       ,category:"Clubhead"},
    {key:"AdjImpVertLocInch",       display:"Adj-Impact Y",         unit:"mm"       ,category:"Clubhead"},
    //{key:"ImpactHorizLocMM",      display:"Impact X",             unit:"mm"       ,category:"Clubhead"},
    //{key:"ImpactVertLocMM",       display:"Impact Y",             unit:"mm"       ,category:"Clubhead"},
    //{key:"AdjImpHorizLocMM",      display:"Adj-Impact X",         unit:"mm"       ,category:"Clubhead"},
    //{key:"AdjImpVertLocMM",       display:"Adj-Impact Y",         unit:"mm"       ,category:"Clubhead"},
    {key:"ImpactHeadSpeedMph",      display:"Head Spd",             unit:"Mph"      ,category:"Clubhead"},
    {key:"ImpactLocHeadSpeed",      display:"Impact Spd",           unit:"Mph"      ,category:"Clubhead"},
    {key:"ImpactYawAngleDeg",       display:"Face",                 unit:"deg"      ,category:"Clubhead"},
    {key:"ImpactPitchAngleDeg",     display:"Loft",                 unit:"deg"      ,category:"Clubhead"},
    {key:"ImpactRollAngleDeg",      display:"Lie",                  unit:"deg"      ,category:"Clubhead"},
    {key:"ImpactAttackAngleDeg",    display:"Attack",               unit:"deg"      ,category:"Clubhead"},
    {key:"ImpactPathAngleDeg",      display:"Head Path",            unit:"deg"      ,category:"Clubhead"},
    {key:"ShotTotalYd",             display:"Total",                unit:"Yds"      ,category:"Flight"},
    {key:"ShotTotalDispFt",         display:"Total Disp.",          unit:"ft"       ,category:"Flight"},
    {key:"ShotCarryYd",             display:"Carry",                unit:"Yds"      ,category:"Flight"},
    {key:"ShotApexFt",              display:"Apex",                 unit:"ft"       ,category:"Flight"},
    {key:"ShotCarryDispFt",         display:"Carry Disp.",          unit:"ft"       ,category:"Flight"},
    {key:"ShotFlightTimeSec",       display:"Flight time",          unit:"sec"      ,category:"Flight"},
    {key:"ShotMaxLateralTravelFt",  display:"Lat. Travel",          unit:"ft"       ,category:"Flight"},
    {key:"BallLandingAngleDeg",     display:"Landing",              unit:"deg"      ,category:"Ball"},
    {key:"ClosureRateDPS",          display:"Closure",              unit:"dps"      ,category:"Clubhead"},
    {key:"BallSpinAxis",            display:"Spin Axis",            unit:"deg"      ,category:"Ball"},
    {key:"BallSpinRPM",             display:"Spin RPM",             unit:"RPM"      ,category:"Ball"},
    {key:"SmashFactor",             display:"Smash",                unit:""         ,category:"Clubhead"},
    {key:"FaceToPath",              display:"Face To Path",         unit:"deg"      ,category:"Clubhead"},
    {key:"MaxAccel",                display:"Max Accel.",           unit:"m/s2"     ,category:"Clubhead"},
    {key:"BackswingTime",           display:"Backswing",            unit:"ms"       ,category:"Clubhead"},
    {key:"DownswingTime",           display:"Downswing",            unit:"ms"       ,category:"Clubhead"},
    {key:"AddressLie",              display:"Add. Lie",             unit:"deg"      ,category:"Clubhead"},
    {key:"AddressLoft",             display:"Add. Loft",            unit:"deg"      ,category:"Clubhead"},
    {key:"AddressFace",             display:"Add. Face",            unit:"deg"      ,category:"Clubhead"},
    {key:"WorldStartX",             display:"Ball X",               unit:"mm"       ,category:"Ball"},
    {key:"WorldStartY",             display:"Ball Y",               unit:"mm"       ,category:"Ball"},
    {key:"WorldStartZ",             display:"Ball Z",               unit:"mm"       ,category:"Ball"},
    {key:"LoftToAttack",            display:"Loft to Attack",       unit:"deg"      ,category:"Clubhead"},
    {key:"DistanceToApex",          display:"Apex Dist.",           unit:"yds"      ,category:"Flight"},
    {key:"TrackingPercentage",      display:"Track Perc.",          unit:""         ,category:"Flight"},

    {key:"SwingLength",             display:"Swing Length",         unit:"deg"      ,category:"Clubhead"},
    {key:"ShaftDirAtTop",           display:"Top Shaft",        unit:"deg"      ,category:"Clubhead"},
    {key:"FaceAtTop",               display:"Top Face",         unit:"deg"      ,category:"Clubhead"},

    {key:"AzimuthDeflectionDeg",        display:"Deflection",           unit:"deg"      ,category:"Ball"},
    {key:"CarryDistanceMm",             display:"Carry",                unit:"mm"       ,category:"Ball"},
    {key:"DecelerationAfterRollMpss",   display:"Decel After",         unit:"mpss"     ,category:"Ball"},
    {key:"FullRollSpinRpm",             display:"Roll Spin",            unit:"RPM"      ,category:"Ball"},
    {key:"IdealBallSpinRpm",            display:"Ideal Spin",           unit:"RPM"      ,category:"Ball"},
    {key:"SkidDistanceMm",              display:"Skid",                 unit:"mm"       ,category:"Ball"},
    {key:"StimpFt",                     display:"Stimp",                unit:"ft"       ,category:"Ball"},
    {key:"TimeToFullRollSec",           display:"Roll Time",            unit:"ft"       ,category:"Ball"},
    {key:"TotalEstimatedDistanceMm",    display:"Total Dist.",          unit:"mm"       ,category:"Ball"},
    {key:"OutInRatio",             display:"post/pre",             unit:""         ,category:"Ball"},
    {key:"pre_BallSpeedMph",       display:"pre Speed",        unit:"mph", category:"Ball"},
    {key:"pre_BallLaunchAngleDeg", display:"pre Launch",     unit:"deg", category:"Ball"},
    {key:"pre_BallSideAngleDeg",   display:"pre Side°",       unit:"deg", category:"Ball"},
    {key:"pre_BallBackSpinRpm",    display:"pre BackSpin",        unit:"rpm", category:"Ball"},
    {key:"pre_BallSideSpinRpm",    display:"pre SideSpin",        unit:"rpm", category:"Ball"},
    {key:"pre_BallSpinAxis",       display:"pre SpinAxis",        unit:"deg", category:"Ball"},
    {key:"pre_BallSpinRPM",        display:"pre SpinRPM",         unit:"rpm", category:"Ball"},
    {key:"pre_WorldStartX",        display:"pre WStartX",         unit:"mm",  category:"Ball"},
    {key:"pre_WorldStartY",        display:"pre WStartY",         unit:"mm",  category:"Ball"},
    {key:"pre_WorldStartZ",        display:"pre WStartZ",         unit:"mm",  category:"Ball"},

    {key:"post_BallSpeedMph",      display:"post Speed",       unit:"mph", category:"Ball"},
    {key:"post_BallLaunchAngleDeg",display:"post Launch",    unit:"deg", category:"Ball"},
    {key:"post_BallSideAngleDeg",  display:"post Side°",      unit:"deg", category:"Ball"},
    {key:"post_BallBackSpinRpm",   display:"post BackSpin",       unit:"rpm", category:"Ball"},
    {key:"post_BallSideSpinRpm",   display:"post SideSpin",       unit:"rpm", category:"Ball"},
    {key:"post_BallSpinAxis",      display:"post SpinAxis",       unit:"deg", category:"Ball"},
    {key:"post_BallSpinRPM",       display:"post SpinRPM",        unit:"rpm", category:"Ball"},
    {key:"post_WorldStartX",       display:"post WStartX",        unit:"mm",  category:"Ball"},
    {key:"post_WorldStartY",       display:"post WStartY",        unit:"mm",  category:"Ball"},
    {key:"post_WorldStartZ",       display:"post WStartZ",        unit:"mm",  category:"Ball"},
];

export const LMList = [
    { type:"COCOON", connected:false,
        color: "#E6E6FA",
        capabilities: [
            "ImpactYawAngleDeg",
            "ImpactPitchAngleDeg",
            "ImpactRollAngleDeg",
            "ImpactHeadSpeedMph",
            "ClosureRateDPS",
            "MaxAccel",
            "BackswingTime",
            "DownswingTime",
            "AddressLie",
            "AddressLoft",
            "AddressFace",
            "HeadingAtAddress",
            "Ground",
            "ImpactAttackAngleDeg",
            "ImpactPathAngleDeg",
            "ImpactHorizLocInch",
            "ImpactVertLocInch",
            "LoftToAttack",
            "FaceToPath",
            "SwingLength",
            "ShaftDirAtTop",
            "FaceAtTop"
        ],
        hasTraj:false,
        vtcCapable:false
    },
    { type:"TOP_TRACER", connected:false,
        color: "#90EE90",
        capabilities:[
            "BallSpeedMph",
            "BallLaunchAngleDeg",
            "ShotCarryYd",
            "ShotCarryDispFt",
            "ShotTotalYd",
            "ShotTotalDispFt",
            "ShotFlightTimeSec",
            "ShotApexFt",
            "DistanceToApex",
            "ShotMaxLateralTravelFt",
            "BallSideAngleDeg",
            "BallBackSpinRpm",
            "BallSideSpinRpm",
            "BallLandingAngleDeg",
            "BallSpinAxis",
            "BallSpinRPM",
            "TrackingPercentage"
        ],
        hasTraj:true,
        vtcCapable:false
    },
    { type:"GC_QUAD", connected:false,
        color: "#87CEFA",
        capabilities:[
            "BallSpeedMph",
            "BallLaunchAngleDeg",
            "BallSideAngleDeg",
            "BallBackSpinRpm",
            "BallSideSpinRpm",
            "BallLandingAngleDeg",
            "ImpactHorizLocInch",
            "ImpactVertLocInch",
            "AdjImpHorizLocInch", 
            "AdjImpVertLocInch",
            //"ImpactHorizLocMM",
            //"ImpactVertLocMM",
            //"AdjImpHorizLocMM", 
            //"AdjImpVertLocMM",
            "ImpactAttackAngleDeg",
            "ImpactYawAngleDeg",
            "ImpactPathAngleDeg",
            "ImpactPitchAngleDeg",
            "ImpactRollAngleDeg",
            "ImpactHeadSpeedMph",
            "ImpactLocHeadSpeed",
            "ClosureRateDPS",
            "BallSpinAxis",
            "BallSpinRPM",
            "SmashFactor",
            "FaceToPath",
            "WorldStartX",
            "WorldStartY",
            "WorldStartZ",
            "ShotApexFt",
            "ShotFlightTimeSec",
            "DistanceToApex",
            "ShotCarryYd",
            "ShotCarryDispFt",
            "ShotTotalYd",
            "ShotTotalDispFt",
            "ShotMaxLateralTravelFt",
            "AzimuthDeflectionDeg",     
            "CarryDistanceMm",          
            "DecelerationAfterRollMpss",
            "FullRollSpinRpm",          
            "IdealBallSpinRpm",         
            "SkidDistanceMm",           
            "StimpFt",                  
            "TimeToFullRollSec",        
            "TotalEstimatedDistanceMm", 
        ],
        hasTraj:true,
        vtcCapable:true
    },
    { type:"TRACKMAN", connected:false,
        color: "#FFFFE0",
        capabilities:[
            "ShotApexFt",
            "ShotFlightTimeSec",
            "ShotCarryYd",
            "ShotCarryDispFt",
            "ShotTotalYd",
            "ShotTotalDispFt",
            "ImpactHeadSpeedMph",
            "ImpactPitchAngleDeg",
            "ImpactYawAngleDeg",
            "ImpactAttackAngleDeg",
            "ImpactPathAngleDeg",
            "BallSpeedMph",
            "BallLaunchAngleDeg",
            "BallSideAngleDeg",
            "BallBackSpinRpm",
            "BallSideSpinRpm",
            "BallSpinAxis",
            "BallSpinRPM",
            "SmashFactor",
            "FaceToPath"
        ],
        hasTraj:true,
        vtcCapable:true
    },
    { type:"HUNTER", connected:false,
        color: "#006400",
        capabilities:[
            "BallSpeedMph",
            "BallLaunchAngleDeg",
            "ShotCarryYd",
            "ShotCarryDispFt",
            "ShotTotalYd",
            "ShotTotalDispFt",
            "ShotFlightTimeSec",
            "ShotApexFt",
            "ShotMaxLateralTravelFt",
            "BallSideAngleDeg",
            "BallBackSpinRpm",
            "BallSideSpinRpm",
            "BallLandingAngleDeg",
            "BallSpinAxis",
            "BallSpinRPM"
        ],
        hasTraj:true,
        vtcCapable:true
    },
    { type:"RESEARCH_QUAD", connected:false,
        color: "#fab387",
        capabilities:[
            "BallSpeedMph",
            "OutInRatio",
            "pre_BallSpeedMph",
            "pre_BallLaunchAngleDeg",
            "pre_BallSideAngleDeg",
            "pre_BallBackSpinRpm",
            "pre_BallSideSpinRpm",
            "pre_BallSpinAxis",
            "pre_BallSpinRPM",
            "pre_WorldStartX",
            "pre_WorldStartY",
            "pre_WorldStartZ",
            
            "post_BallSpeedMph",
            "post_BallLaunchAngleDeg",
            "post_BallSideAngleDeg",
            "post_BallBackSpinRpm",
            "post_BallSideSpinRpm",
            "post_BallSpinAxis",
            "post_BallSpinRPM",
            "post_WorldStartX",
            "post_WorldStartY",
            "post_WorldStartZ"
        ],
        hasTraj:false,
        vtcCapable:false
    },
];

export const SetupColors = [
    {"bg":"#ff0000", "fg":"#ffffff"}, // red -> white for contrast
    {"bg":"#0000ff", "fg":"#ffffff"}, // blue -> white for contrast
    {"bg":"#ffff00", "fg":"#000000"}, // yellow -> black for contrast
    {"bg":"#008000", "fg":"#ffffff"}, // green -> white for contrast
    {"bg":"#400080", "fg":"#ffffff"}, // purple -> white for contrast
    {"bg":"#00ffff", "fg":"#000000"}, // cyan -> black for contrast
    {"bg":"#ff8000", "fg":"#000000"}, // orange -> black for contrast
    {"bg":"#ff00ff", "fg":"#000000"}, // magenta -> black for contrast
    {"bg":"#dfff00", "fg":"#000000"}, // chartreuse -> black for contrast
    {"bg":"#ffc0cb", "fg":"#000000"}, // pink -> black for contrast
    {"bg":"#ffd700", "fg":"#000000"}, // gold -> black for contrast
    {"bg":"#964b00", "fg":"#ffffff"}, // brown -> white for contrast
];

const DEFAULT_SETUP_COLOR = { bg: '#444444', fg: '#ffffff' };
const NO_SETUP_COLOR = { bg: 'transparent', fg: 'inherit' };

export function getSetupColor(setup, index = 0) {
    const corType = setup?.TestParameters?.CORType;

    switch (corType) {
        case 'Center':
            return SetupColors[1];
        case 'Hot Spot':
            return SetupColors[0];
        case 'Other':
            return SetupColors[3];
        case 'Plate':
            return NO_SETUP_COLOR;
        default:
            return SetupColors[index % SetupColors.length] || DEFAULT_SETUP_COLOR;
    }
}
